var tooltipStyles = {
  root: function root() {
    return {};
  },
  content: function content(_ref) {
    var v = _ref.variables,
        p = _ref.props;
    return Object.assign({}, !p.open && {
      opacity: 0
    }, {
      zIndex: v.zIndex,
      position: 'absolute',
      textAlign: 'left'
    });
  }
};
export default tooltipStyles;